{
  "card": {
    "title": "Estado de Financiamiento"
  },
  "status": {
    "not_funded": "Sin Financiar",
    "partially_funded": "Parcialmente Financiado",
    "pending_review": "Pendiente de Revisión",
    "eligible": "Elegible",
    "pending": "Pendiente"
  },
  "progress": {
    "required": "Contribución Requerida",
    "funded": "Contribuciones Confirmadas",
    "pending": "Pendiente de Revisión",
    "remaining": "Restante por Financiar"
  },
  "alerts": {
    "pendingReview": {
      "title": "Contribución en Revisión",
      "description": "Su contribución está siendo revisada por un administrador. Se le notificará una vez que sea confirmada."
    },
    "notFunded": {
      "title": "Contribución Requerida",
      "description": "Debe enviar su contribución inicial para ser elegible para asignaciones de ganancias. Revise las instrucciones de pago a continuación y envíe los detalles de su contribución una vez enviada."
    }
  },
  "eligible": {
    "title": "Totalmente Financiado",
    "subtitle": "Es elegible para asignaciones de ganancias",
    "basePrincipal": "Capital Base"
  },
  "pending": {
    "title": "Contribuciones Pendientes",
    "sentOn": "Enviado el",
    "method": "Método de Pago",
    "reference": "Referencia"
  },
  "instructions": {
    "title": "Instrucciones de Pago"
  },
  "form": {
    "title": "Registre su Contribución",
    "logContribution": "Registrar una Contribución",
    "amount": {
      "label": "Monto Enviado",
      "placeholder": "Ingrese el monto",
      "required": "Por favor ingrese el monto que envió",
      "min": "El monto debe ser mayor que 0",
      "remaining": "Restante necesario: {{amount}}"
    },
    "sentAt": {
      "label": "Fecha de Envío",
      "required": "Por favor seleccione la fecha en que envió el pago"
    },
    "paymentMethod": {
      "label": "Método de Pago",
      "placeholder": "Seleccione método de pago",
      "required": "Por favor seleccione un método de pago"
    },
    "reference": {
      "label": "Referencia / ID de Transacción (Opcional)",
      "placeholder": "ej., Últimos 4 dígitos, número de confirmación",
      "help": "Cualquier número de referencia o identificador de su transferencia"
    },
    "note": {
      "label": "Notas Adicionales (Opcional)",
      "placeholder": "Cualquier información adicional sobre esta transferencia",
      "help": "Esto ayudará al administrador a verificar su contribución"
    },
    "submit": "Enviar para Revisión",
    "cancel": "Cancelar",
    "submitSuccess": "¡Contribución enviada exitosamente! Un administrador la revisará pronto.",
    "submitError": "Error al enviar la contribución. Por favor intente nuevamente."
  },
  "paymentMethods": {
    "bank_transfer": "Transferencia Bancaria",
    "zelle": "Zelle",
    "cash_app": "Cash App",
    "venmo": "Venmo",
    "other": "Otro"
  },
  "errors": {
    "loadFailed": "No se pudo cargar el estado de contribución"
  },
  "bankDeposit": {
    "title": "Depósito Bancario",
    "description": "Financie su cuenta directamente desde su cuenta bancaria vinculada",
    "methodChoice": {
      "title": "Elija el Método de Financiamiento",
      "description": "Seleccione cómo le gustaría financiar su cuenta para ser elegible para asignaciones de ganancias.",
      "bankOption": "Conectar Cuenta Bancaria",
      "bankDescription": "Transferir fondos directamente desde su cuenta bancaria vía ACH",
      "manualOption": "Financiamiento Manual",
      "manualDescription": "Enviar pago fuera de la plataforma y registrarlo para revisión del admin"
    },
    "authorize": {
      "button": "Autorizar Depósito",
      "retry": "Reintentar Depósito",
      "confirm": "Confirmar Depósito",
      "cancel": "Cancelar",
      "title": "Autorizar Depósito Inicial",
      "description": "Está a punto de autorizar un depósito ACH desde su cuenta bancaria predeterminada.",
      "amount": "Monto del Depósito",
      "bankAccount": "Desde Cuenta Bancaria",
      "processing": "Procesando depósito..."
    },
    "status": {
      "pending": "Depósito Pendiente",
      "processing": "Depósito en Proceso",
      "completed": "Depósito Completado",
      "failed": "Depósito Fallido",
      "succeeded": "Depósito Exitoso",
      "cancelled": "Depósito Cancelado",
      "pendingDescription": "Su solicitud de depósito ha sido creada y está esperando procesamiento.",
      "processingDescription": "Su depósito está siendo procesado. Esto generalmente toma de 1 a 3 días hábiles.",
      "succeededDescription": "¡Su depósito se ha completado exitosamente!",
      "failedDescription": "Su depósito falló. Puede intentar de nuevo o contactar soporte.",
      "cancelledDescription": "Su depósito fue cancelado.",
      "completedTitle": "Depósito Confirmado — ¡Ahora Eres Elegible!",
      "completedDescription": "Su depósito ha sido confirmado y acreditado exitosamente a su cuenta. Ahora es elegible para asignaciones de ganancias.",
      "amount": "Monto",
      "created": "Creado",
      "transferId": "ID de Transferencia",
      "failureReason": "Razón del Fallo"
    },
    "refresh": {
      "button": "Actualizar Estado",
      "success": "Estado de transferencia actualizado",
      "error": "No se pudo actualizar el estado. Por favor, inténtelo de nuevo."
    },
    "errors": {
      "noBankAccount": "Primero debe vincular una cuenta bancaria",
      "noDefaultAccount": "Debe tener una cuenta bancaria predeterminada activa",
      "alreadyEligible": "Ya es elegible para ganancias",
      "pendingDeposit": "Ya tiene un depósito pendiente",
      "createFailed": "No se pudo crear la solicitud de depósito. Por favor, inténtelo de nuevo."
    },
    "success": {
      "created": "¡Solicitud de depósito creada exitosamente!"
    },
    "backToManual": "Usar Financiamiento Manual en su Lugar"
  }
}
